/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TCheckPaymentByProviderModel = IModel<ICheckPaymentByProviderRequest, TCheckPaymentByProviderResponse>;

export interface ICheckPaymentByProviderRequest {
  /** Провайдер платежей **/
  paymentProvider?: EPaymentProvider | null;
  /** Внешний id платежа провайдера **/
  externalPaymentId?: string | null;
}

export type TCheckPaymentByProviderResponse = ICheckPaymentByProviderResponse200 | ICheckPaymentByProviderResponse400;

export interface ICheckPaymentByProviderResponse200 extends IModelResponse<ICheckPaymentByProviderResponse> {
  statusCode: 200;
}

export interface ICheckPaymentByProviderResponse400 extends IModelResponse<ICheckPaymentByProviderResponseError> {
  statusCode: 400;
}

export interface ICheckPaymentByProviderResponse {
  /** Статус платежа **/
  status?: EStatus | null;
}

export interface ICheckPaymentByProviderResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICheckPaymentByProviderResponse | ICheckPaymentByProviderResponseError;

export enum EStatus {
  /** Платёж прошёл успешно **/
  Succeeded = 'succeeded',
  /** Статус платежа пока не определён **/
  Pending = 'pending',
  /** Платёж отменён **/
  Canceled = 'canceled',
}

export enum EPaymentProvider {
  /** Провайдер неопределен **/
  Unknown = 'unknown',
  /** ЮKassа (https://yookassa.ru/developers) **/
  YooKassa = 'yooKassa',
  /** CloudPayments (https://developers.cloudpayments.ru/#svodka-izmeneniy) **/
  CloudPayments = 'cloudPayments',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICheckPaymentByProviderResponse): TResponse200;
  400(response: ICheckPaymentByProviderResponseError): TResponse400;
}
